import { createAction } from '@reduxjs/toolkit';

// NOTE: for some reason `createAction` doesn't seem to produce action creators other than ones with optional payload
export const createTypedAction =
  <Payload = undefined>() =>
  <Type extends string>(type: Type) =>
    createAction<Payload, Type>(type);
